export const isNullable = (x: unknown): x is null | undefined =>
  x === undefined || x === null;
